import { render, staticRenderFns } from "./orderBills.vue?vue&type=template&id=34a4f085&scoped=true"
import script from "./orderBills.vue?vue&type=script&lang=js"
export * from "./orderBills.vue?vue&type=script&lang=js"
import style0 from "./orderBills.vue?vue&type=style&index=0&id=34a4f085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a4f085",
  null
  
)

export default component.exports